<template>
  <div class="form-row">
    <div v-if="!inline" class="col item-container" style="text-align: left;">
      <label class="label-item" :for="prop">{{ label }}</label>
      <input :id="prop" :type="type" :class="`form-control form-control-sm ${validation ? (isValid ? 'is-valid' : 'is-invalid') : ''}`"
        v-model="value"/>
      <div v-if="validation && isValid" class="valid-feedback">{{ validationMessage }}</div>
      <div v-if="validation && !isValid" class="invalid-feedback">{{ validationMessage }}</div>
    </div>
    <label v-if="inline" :for="prop" class="col-sm-4 col-form-label label-item" style="text-align: left;">{{ label }}</label>
    <div v-if="inline" class="col-sm">
      <input :id="prop" :type="type" :class="`form-control form-control-sm ${validation ? (isValid ? 'is-valid' : 'is-invalid') : ''}`"
             v-model="value">
    </div>
    <div v-if="inline & validation && isValid" class="valid-feedback">{{ validationMessage }}</div>
    <div v-if="inline & validation && !isValid" class="invalid-feedback">{{ validationMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    prop: String,
    type: String,
    label: String
  },
  data () {
    return {
      validation: false,
      validationMessage: 'Mesnaje de validacion',
      isValid: false,
      value: ''
    }
  },
  watch: {
    value: function (v) {
      this.$emit('input', v)
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
  .item-container {
    margin-bottom: 10px;
  }
  .label-item {
    font-size: 13.5px!important;
    margin-bottom: 0.3rem;
  }
</style>
